import { LOGOS_URL } from '../config';
import logo from './default.jpg';

const getLogo = (target) => {
    if(target.logo)
        return LOGOS_URL + target.logo.base + target.logo.name;
    else
        return logo;
};

export default getLogo;
